import React, { useEffect } from 'react';
import { useAppSettings } from '../../contexts/AppSettingsContext';

const TitleUpdater: React.FC = () => {
  const { settings } = useAppSettings();
  
  useEffect(() => {
    // Update the document title using the company name
    if (settings.companyName) {
      document.title = `${settings.companyName} AI Tranzcribe™`;
    } else {
      document.title = 'Tranzcribe AI™'; // Default title if no company name is set
    }
  }, [settings.companyName]);
  
  // This component doesn't render anything
  return null;
};

export default TitleUpdater; 